export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_02.dd4cc856.jpg";